import { render } from "./TmsOwnershipNote.vue?vue&type=template&id=25c7d40b&scoped=true"
import script from "./TmsOwnershipNote.vue?vue&type=script&lang=js"
export * from "./TmsOwnershipNote.vue?vue&type=script&lang=js"

import "./TmsOwnershipNote.vue?vue&type=style&index=0&id=25c7d40b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c7d40b"]])

export default __exports__